import React, { useState, useCallback } from "react";
import styled from "styled-components";
import Edit from "./slateEditor";
import Text from "./index";
import useOnClickOutside from "use-onclickoutside";
import { Transition } from "react-transition-group";
import { injectIntl } from "react-intl";

const Wrapper = styled.div`
  overflow-wrap: break-word;
  hyphens: auto;
`;

const TextEdit = (props) => {
  const { extra, user = {}, setIsDndDisabled = () => {} } = props;
  const { editInPortal = false } = extra;
  const { accessibility = false } = user;
  const [selected, setSelected] = useState(false);
  const [animate] = useState(false);

  const ref = React.useRef(null);
  useOnClickOutside(ref, () => {
    setSelected(false);
    setIsDndDisabled(false);
  });

  const switchToEdit = useCallback(() => {
    if (editInPortal) {
      return;
    }

    setSelected(true);
    setIsDndDisabled(true);
  }, [animate, selected]);

  return selected || accessibility ? (
    <Transition in={true} appear={true} timeout={150}>
      {(state) => (
        <Wrapper ref={ref} state={state}>
          <Edit {...props} state={state} />
        </Wrapper>
      )}
    </Transition>
  ) : (
    <Transition timeout={150}>
      {(state) => {
        return (
          <Wrapper state={state} onClick={switchToEdit}>
            <Text {...props} />
          </Wrapper>
        );
      }}
    </Transition>
  );
};

export default injectIntl(TextEdit);
